import { Seo } from "@/components/site/Seo";
import { ProductCard } from "@/components/site/ProductCard";
import { useProducts } from "@/lib/useProducts";
import { Skeleton } from "@/components/ui/skeleton";

export default function Products() {
  const { data: products, isLoading } = useProducts();
  return (
    <>
      <Seo title="Products" description="Export specs, packing, MOQ and season calendar for G9 banana, red onion and Bhagwa pomegranate from India." path="/products" />
      <section className="max-w-7xl mx-auto px-6 md:px-12 py-24">
        <div className="max-w-2xl space-y-4 mb-14">
          <p className="text-xs uppercase tracking-[0.25em] text-emerald-800">Products</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight">What we export</h1>
          <p className="text-stone-600">Sold by the container on FOB or CIF terms. Open a product to see specs, carton options and its season.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-testid="products-grid">
          {isLoading && [1, 2, 3].map((i) => <Skeleton key={i} className="h-96 rounded-lg" />)}
          {products?.map((p) => <ProductCard key={p.slug} product={p} />)}
        </div>
      </section>
    </>
  );
}
